module.exports = __webpack_public_path__ + "static/img/pictureA.8d7fa92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/pictureA.jpg
// module id = 4qUL
// module chunks = 0